<script context="module">
  import {
    CachedRenderer,
    CanvasPoolManager,
  } from "../util/fast-canvas-pool.js";

  // import { CanvasPool } from "../util/canvas-pool";
  let scrollTop;

  const DIMENSIONS = 768;
  const canvasPoolCache = CachedRenderer({ size: 32 });

  // const canvasPool = CanvasPool({
  //   dimensions: DIMENSIONS,
  //   count: 32,
  // });
</script>

<script>
  import {
    createRandomEncoding,
    createEmptyEncoding,
    hexToEncoding,
    encodingToHex,
  } from "bitframes";
  import LockIcon from "../icons/lock.svelte";
  import StaticArtwork from "./StaticArtwork.svelte";
  import { link } from "../util/anchor-link.js";
  import {
    colorSpace,
    CONTRACTS,
    LINK_EDITIONS,
    LINK_GALLERY,
  } from "../util/constants";
  import UserLink from "./UserLink.svelte";
  import { fetchTokens } from "../util/data-fetcher";
  import { beforeUpdate, onDestroy, onMount } from "svelte";
  import ListBreaker from "./ListBreaker.svelte";

  export let max = 3;
  export let mode = "thumb";

  const pool = CanvasPoolManager({
    hatch: true,
    hatchContours: false,
    maxPaintsPerFrame: 2,
    maxPerFrame: 16,
    cache: canvasPoolCache,
    colorSpace,
    width: DIMENSIONS,
    height: DIMENSIONS,
  });

  const poolAction = pool.action;

  const breakers = new Map();
  breakers.set(0, "Week 1");
  breakers.set(4, "Week 2");
  breakers.set(8, "Week 3");
  breakers.set(12, "Week 4");
  breakers.set(16, "Reserved for Top Contributors");

  let hasLoaded = false;
  let promise;
  let tokens = Array(max)
    .fill(null)
    .map(() => {
      return {
        encoding: null, // createRandomEncoding(undefined, { system: 1 }),
      };
    });
  let container;

  onMount(() => {
    loadOnce();
    if (scrollTop != null) {
      console.log(scrollTop);
      document.documentElement.scrollTop = scrollTop;
    }
    return () => {
      pool.destroy();
      // scrollTop = document.documentElement.scrollTop;
      // console.log(scrollTop);
    };
  });

  onDestroy(() => {
    // console.log(document.documentElement.scrollTop);
  });

  async function loadOnce() {
    if (promise) return promise;
    else return load();
  }

  async function load() {
    hasLoaded = false;
    const data = await fetchTokens({
      contract: CONTRACTS.NFT_LIMITED.address,
      length: 32,
      compact: false,
    });
    tokens = Array(max)
      .fill()
      .map((_, i) => {
        if (i < data.length) {
          const d = data[i];
          let encoding = createEmptyEncoding({ system: 0x01 });
          try {
            encoding = hexToEncoding(d.seed);
          } catch (err) {}
          return {
            tokenId: d.token_id,
            owner: d.owned_address || null,
            encoding,
          };
        } else {
          return {
            encoding: null,
          };
        }
      });
    // console.log("NEW TOKENS", tokens);
    hasLoaded = true;
    // console.log(data);
  }

  function toHex(e) {
    return typeof e === "string" ? e : encodingToHex(e);
  }
</script>

<div class="container" class:list={mode == "list"} bind:this={container}>
  <div class="gallery" class:list={mode == "list"}>
    {#each tokens as cell, i (i + "-" + cell.encoding)}
      {#if mode == "list"}<ListBreaker index={i} />{/if}
      <!-- {#if mode == "list" && breakers.has(i)}
        <div class="breaker" class:firstBreaker={i == 0}>{breakers.get(i)}</div>
      {/if} -->

      <a
        class="cell-link"
        use:link
        class:linkable={hasLoaded && cell.encoding}
        href={hasLoaded && cell.encoding
          ? `/${LINK_EDITIONS}/token/${cell.tokenId}`
          : null}
      >
        <div class="cell-container">
          <div class="cell">
            {#if mode == "list"}
              <div class="id">
                #{cell.tokenId || i + 1}
              </div>
            {/if}
            {#if hasLoaded && cell.encoding}
              <div
                class="artwork-container"
                data-index={i}
                data-encoding={toHex(cell.encoding)}
                use:poolAction
              >
                <!-- <StaticArtwork
                  on:click={(ev) => {
                    const top = document.documentElement.scrollTop;
                    scrollTop = top;
                    console.log(scrollTop);
                  }}
                  canvasResolution={768}
                  lazyRender={true}
                  displayPadding={0}
                  encoding={cell.encoding}
                /> -->
              </div>
            {:else}
              <div class="placeholder noselect svg-container">
                {#if hasLoaded}
                  <!-- <img src={lockIcon} alt="" /> -->
                  <LockIcon></LockIcon>
                {/if}
              </div>
            {/if}

            <div class="labels">
              {#if mode != "list"}
                <div class="id">
                  #{cell.tokenId || i + 1}
                </div>
                <div class="reveal">
                  {#if !cell.encoding && hasLoaded && i < 32}REVEALED WITHIN {i <
                    16
                      ? "24"
                      : "72"}
                    HRS{/if}
                </div>
              {/if}
              {#if cell.encoding && hasLoaded && cell.owner}
                <div class="owner">
                  <UserLink
                    link={false}
                    resolve
                    short={mode != "list"}
                    address={cell.owner}
                  />
                </div>
              {:else if mode == "list" || !hasLoaded}
                <div class="placeholder-label noselect">
                  {#if hasLoaded}
                    <div class="unrevealed">
                      {#if i < 32}REVEALED WITHIN {i < 16 ? "24" : "72"} HRS{:else}LOCKED{/if}
                    </div>
                  {:else}
                    ..
                  {/if}
                </div>
              {/if}
            </div>
          </div>
        </div>
      </a>
    {/each}
  </div>
</div>

<style>
  .container {
    --list-cell-size: 128px;
    --cell-size: 256px;
    --columns: 4;
    --gap: 20px;
    width: 100%;
    /* height: 100%; */
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-sizing: border-box;
    /* align-items: flex-start; */
  }
  .placeholder {
    background: black;
    aspect-ratio: 1;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
  }
  :global(.placeholder.svg-container svg) {
    width: 30px;
    height: auto;
  }
  .owner {
    /* max-width: 100px; */
    display: flex;
  }
  .list .owner {
    /* max-width: 100%; */
    padding-left: 20px;
    box-sizing: border-box;
    padding-right: 20px;
    flex-grow: 1;
    /* width: 100%; */
    overflow: hidden;
  }
  .placeholder-label {
    padding-left: 20px;
  }
  .cell-container {
    display: flex;
    width: 100%;
    height: 100%;
  }
  .artwork-container {
    aspect-ratio: 1;
    width: 100%;
    height: 100%;
    display: flex;
  }
  .list .artwork-container {
    width: initial;
  }
  .cell-link {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-grow: 1;
    flex-shrink: 1;
    color: currentColor;
    appearance: none;
    box-sizing: border-box;
    outline: 0;
    font: inherit;
    text-decoration: none;
    width: 100%;
    /* height: 100%; */
    cursor: default;
    flex-direction: row;
  }
  .cell-link.linkable {
    cursor: pointer;
  }
  .list .cell-link {
    width: 100%;
    flex-grow: 1;
    padding: 0px;
    padding-left: 0px;
    box-sizing: border-box;
    /* margin-left: -10px; */
    /* margin-right: -10px; */
    /* padding-right: 10px; */
  }

  @media (hover: hover) {
    .list .cell-link.linkable:hover {
      background: hsl(0, 0%, 95%);
    }
  }

  .list .id {
    flex-basis: 40px;
    display: flex;
    box-sizing: border-box;
    flex-shrink: 0;
    padding-left: 0px;
    padding-right: 10px;
    justify-content: flex-start;
    /* align-self: flex-start; */
  }
  .list .cell-container {
    flex-grow: 1;
    width: 100%;
    height: initial;
    /* height: 128px; */
    /* background-color: pink; */
  }

  .list .cell {
    flex-direction: row;
    /* background: red; */
    width: 100%;
    height: var(--list-cell-size);
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .gallery {
    /* margin-top: 20px; */
    /* margin-bottom: 20px; */
    flex-grow: 1;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 0px;
    /* flex-wrap: wrap; */
    /* flex-flow: wrap; */

    /* grid-template-columns: repeat(auto-fit, minmax(128px, 1fr)); */

    /* grid-template-columns: repeat(2, 1fr); */
    grid-template-columns: repeat(var(--columns), minmax(32px, 1fr));
    /* grid-template-rows: repeat(2, 1fr); */
    display: grid;
    grid-gap: var(--gap);
    box-sizing: border-box;
  }
  .gallery.list {
    display: flex;
    flex-direction: column;
    gap: 10px;
    /* width: 100%; */
    justify-content: stretch;
    flex-grow: 1;
  }
  .cell {
    /* aspect-ratio: 1; */
    display: flex;
    /* justify-content: center; */
    /* align-items: center; */
    width: 100%;
    height: 100%;

    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    margin-bottom: 20px;
    /* cursor: pointer; */
  }
  .list .cell {
    aspect-ratio: initial;
    margin-bottom: 0;
  }
  .list .cell a,
  .list .placeholder {
    width: auto;
    aspect-ratio: 1;
    height: 100%;
  }
  .labels {
    padding-top: 2.5px;
    /* padding-left: 5px; */
    /* padding-right: 5px; */
    box-sizing: border-box;
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: flex-start;
    font-size: 12px;
  }

  .list .labels {
    flex-grow: 1;
    width: 100%;
    overflow: hidden;
    padding: 0;
  }
  @media screen and (max-width: 1000px) {
    .container {
      --list-cell-size: 128px;
    }
  }
  @media screen and (max-width: 800px) {
    .container {
      --list-cell-size: 64px;
    }
  }
  @media screen and (max-width: 800px) {
    .container {
      /* padding: 20px; */
      --gap: 10px;
      --columns: 2;
    }
  }
</style>
